import React from "react";
import flowers from "../data/bucheteIarnaPrimavara";
import FlowerContainer from "../components/FlowerContainer";

const BucheteIarnaPrimavara = () => {
  return (
    <FlowerContainer
      flowers={flowers}
      title="Buchete de iarnă/primavară"
      subtitle="Flori delicate care îmbină farmecul iernii cu prospețimea primăverii."
      storageKey="BUCHETE_IARNA_PRIMAVARA_SCROLL_POSITION"
    />
  );
};

export default BucheteIarnaPrimavara;
